import { useEffect, useCallback, useState } from 'react';
import { useComponentState, useInvokeCapability } from 'navigation-components/consumer/hooks';
import { capabilities } from 'navigation-components/capabilities';
import { Metrics, OPEN_REMOTE } from 'calling-remote-common/utils/Metrics';
export const initialState = {
  openRemote: () => {},
  closeRemote: () => {},
  setIsPopoverMinimized: () => {},
  isPopoverMinimized: false,
  hasThirdPartyOpened: false,
  setHasThirdPartyOpened: () => {}
};
export function useOpenCloseRemote() {
  const {
    isOpen
  } = useComponentState();
  const closeRemoteCap = useInvokeCapability(capabilities.HIDE_COMPONENT_CAP);
  const openRemoteCap = useInvokeCapability(capabilities.SHOW_COMPONENT_CAP);
  const [hasThirdPartyOpened, setHasThirdPartyOpened] = useState(isOpen);
  useEffect(() => {
    if (isOpen && !hasThirdPartyOpened) setHasThirdPartyOpened(true);
  }, [isOpen, hasThirdPartyOpened]);
  const openRemote = useCallback(() => {
    openRemoteCap();
    Metrics.counter(OPEN_REMOTE, {
      source: 'third-party-popup-opened'
    }).increment();
  }, [openRemoteCap]);
  const setIsPopoverMinimized = useCallback(minimizePopover => {
    if (minimizePopover) {
      closeRemoteCap();
    } else {
      openRemote();
    }
  }, [closeRemoteCap, openRemote]);
  return {
    openRemote,
    closeRemote: closeRemoteCap,
    setIsPopoverMinimized,
    isPopoverMinimized: !isOpen,
    hasThirdPartyOpened,
    setHasThirdPartyOpened
  };
}